export default __webpack_public_path__ + "static/media/07.7d6c0516.jpg";